import { render, staticRenderFns } from "./SquareButton.vue?vue&type=template&id=04cf0f35&scoped=true&"
import script from "./SquareButton.vue?vue&type=script&lang=ts&"
export * from "./SquareButton.vue?vue&type=script&lang=ts&"
import style0 from "./SquareButton.vue?vue&type=style&index=0&id=04cf0f35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf0f35",
  null
  
)

export default component.exports